export default __webpack_public_path__ + "static/media/melania-bruise.2d4dc2aa.jpg";